import React from 'react'
import { PoseGroup } from 'react-pose'
import { useToggle } from '../../hooks'
import {
    StyledCardDrawer,
    StyledCardDrawerWrapper,
    StyledCardDrawerLeft,
    StyledCardDrawerRight,
    StyledCardItemName,
    StyledCardItemValue,
    StyledCardDrawerContent
} from './styled'



const CardDrawer = ({ name, value, active, renderOpenButton, renderContentDrawer }) => {
    const [isOpen, toggleIsOpen] = useToggle(false)
    return (
        <StyledCardDrawer>
            <StyledCardDrawerWrapper>
                <StyledCardDrawerLeft>
                    <StyledCardItemName>{name}</StyledCardItemName>
                    {
                        !isOpen &&
                        <StyledCardItemValue active={active}>{value}</StyledCardItemValue>
                    }
                </StyledCardDrawerLeft>
                <StyledCardDrawerRight pose={!isOpen ? 'visible' : 'hidden'}>
                    {renderOpenButton && renderOpenButton({ handleToggleIsOpenDrawer: toggleIsOpen })}
                </StyledCardDrawerRight>
            </StyledCardDrawerWrapper>
            {
                renderContentDrawer &&
                <PoseGroup>
                    <StyledCardDrawerContent key='card_drawer_content' pose={isOpen ? 'visible' : 'hidden'}>
                        {
                            renderContentDrawer({ handleToggleIsOpenDrawer: toggleIsOpen })
                        }
                    </StyledCardDrawerContent>
                </PoseGroup>
            }
        </StyledCardDrawer>
    )
}

export default CardDrawer
